import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=0fe0ade2&scoped=true&"
import script from "./Background.vue?vue&type=script&lang=javascript&"
export * from "./Background.vue?vue&type=script&lang=javascript&"
import style0 from "./Background.vue?vue&type=style&index=0&id=0fe0ade2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0ade2",
  null
  
)

export default component.exports